// Admin Panel -> ⚙ System -> 🔏 Data Privacy.
// Two tabs: the retention policy commitment, and the DPDP erasure-request
// review queue. Tabs are part of the URL (ADMIN_SUBTABS in adminRegistry.ts).
import AdminTabs from '../AdminTabs';
import { useAdminSubTab } from '../adminRoute';
import RetentionPolicyTab from './RetentionPolicyTab';
import ErasureRequestsTab from './ErasureRequestsTab';

export default function DataPrivacyTab() {
  const tabs = useAdminSubTab('data-privacy');
  const tab = tabs.active;

  return (
    <div className="fade-in">
      <AdminTabs state={tabs} />
      {tab === 'retention' && <RetentionPolicyTab />}
      {tab === 'erasure' && <ErasureRequestsTab />}
    </div>
  );
}
